module.exports = {
    assertEmpty: function(value, fieldName) {
        /**
         * Throws error when variable is empty or not set
         * @param {String|Object} value - The value to check
         * @param fieldName - the name of the field (key)
         */

        if (value === null || typeof value === 'undefined' || value === '' || value === {}) {
            throw 'field \'' + fieldName || 'undefined' + '\' is required but not set';
        }
    },

    merge: function(objects) {
        /**
         * @param {...Object} objects - objects to merge.
         * Merges multiple objectst to one. Last object wins. Returns the merged object, without overwriting the objects.
         * @returns {Object} merged object
         */
        var res = {};
        for (var i = 0; arguments.length > i; i++) {
            if (typeof arguments !== 'object') {
                throw 'argument ' + i + ' is not an object';
            }
            for (var attribute in arguments[i]) {
                if (arguments[i].hasOwnProperty(attribute)) {
                    res[attribute] = arguments[i][attribute];
                }
            }
        }
        return res;
    },

    values: function(object) {
        let a = [];
        for (let key in object) {
            a.push(object[key]);
        }
        return a;
    },

    isJsonString: function(string) {
        if (!string || string === '') return false;
        else if (typeof (string) !== 'string') return false;
        else {
            try {
                JSON.parse(string);
                return true;
            } catch (e) {
                return false;
            }
        }
    },

    reverseObject: function(rMap, f) {
        /*eslint-disable*/
        var _id = function (x) {
            return x;
        };
        return Object.keys(rMap).reduce(function (acc, k) {
            rMap[k].forEach(function (x) {
                acc[x] = (f || _id)(k)
            });
            return acc;
        }, {});
    }
};



// WEBPACK FOOTER //
// ./src/util/object_utils.js